import * as ActionTypes from './ActionTypes';
// import { DISHES } from '../shared/dishes';
import { baseUrl } from '../shared/baseUrl';
import { actions } from 'react-redux-form';

// Token refresh action creators
export const requestTokenRefresh = () => ({
  type: ActionTypes.TOKEN_REFRESH_REQUEST
});

export const receiveTokenRefresh = response => ({
  type: ActionTypes.TOKEN_REFRESH_SUCCESS,
  token: response.token,
  refreshToken: response.refreshToken,
  id: response.id
});

export const tokenRefreshError = message => ({
  type: ActionTypes.TOKEN_REFRESH_FAILURE,
  message
});

// Flag to prevent multiple simultaneous refresh attempts
let isRefreshing = false;
let refreshPromise = null;

// Refresh access token using refresh token
export const refreshAccessToken = () => dispatch => {
  if (isRefreshing) {
    return refreshPromise;
  }

  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    return Promise.reject(new Error('No refresh token available'));
  }

  isRefreshing = true;
  dispatch(requestTokenRefresh());

  refreshPromise = fetch(baseUrl + 'users/refresh-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ refreshToken })
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Token refresh failed');
    })
    .then(response => {
      if (response.success) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('id', response.id);
        dispatch(receiveTokenRefresh(response));
        return response.token;
      }
      throw new Error('Token refresh failed');
    })
    .catch(error => {
      dispatch(tokenRefreshError(error.message));
      throw error;
    })
    .finally(() => {
      isRefreshing = false;
      refreshPromise = null;
    });

  return refreshPromise;
};

// Browsers reject fetch(..., { keepalive: true }) outright with a "Failed to
// fetch" TypeError once the request body is too large (~64KB) - this can
// happen for reason/condition fields with pasted images. Only ask for
// keepalive when the body is safely under that limit.
const KEEPALIVE_BODY_LIMIT = 60000; // bytes, with margin under the ~64KB cap

const canUseKeepalive = (body) => {
  if (typeof body !== 'string') return true;
  if (typeof Blob !== 'undefined') {
    return new Blob([body]).size < KEEPALIVE_BODY_LIMIT;
  }
  return body.length < KEEPALIVE_BODY_LIMIT;
};

// Fetch wrapper that handles 401 errors with automatic token refresh
export const fetchWithAuth = (url, options = {}, dispatch, onLogout) => {
  const token = localStorage.getItem('token');

  // No token at all - skip the request and reject immediately
  if (!token) {
    return Promise.reject(new Error('No access token available'));
  }

  const authOptions = {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    credentials: 'same-origin',
    // Let the browser keep this request alive if the page is backgrounded/
    // navigated away from right after it's sent (e.g. mobile Safari pausing
    // or dropping in-flight requests the instant a tab is backgrounded) -
    // otherwise a save triggered right before switching apps can be lost.
    keepalive: canUseKeepalive(options.body)
  };

  return fetch(url, authOptions).then(response => {
    if (response.status === 401) {
      // Token expired, try to refresh
      return dispatch(refreshAccessToken())
        .then(newToken => {
          // Retry with new token
          const retryOptions = {
            ...options,
            headers: {
              ...options.headers,
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + newToken
            },
            credentials: 'same-origin',
            keepalive: canUseKeepalive(options.body)
          };
          return fetch(url, retryOptions);
        })
        .catch(error => {
          // Refresh failed, logout user
          if (onLogout) {
            dispatch(onLogout());
          }
          throw error;
        });
    }
    return response;
  });
};

export const kirksLoading = () => ({
  type: ActionTypes.KIRKS_LOADING
});

export const inputsLoading = () => ({
  type: ActionTypes.INPUTS_LOADING
});

export const proInputsLoading = () => ({
  // pro
  type: ActionTypes.PROINPUTS_LOADING
});

export const kirksUpdatintg = () => ({
  type: ActionTypes.KIRKS_UPDATING
});

export const inputsUpdatintg = (inputId) => ({
  type: ActionTypes.INPUTS_UPDATING,
  payload: inputId
});

export const proInputsUpdatintg = (proInputId) => ({
  // pro
  type: ActionTypes.PROINPUTS_UPDATING,
  payload: proInputId
});

export const fetchKirks = () => dispatch => {
  dispatch(kirksLoading(true));

  return fetchWithAuth(
    baseUrl + 'kirks',
    { method: 'GET' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            `Error ${response.status} : ${response.statusText}`
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then(response => response.json())
    .then(kirks => dispatch(addKirks(kirks)))
    .catch(error =>
      dispatch(
        kirksFailed(
          <div className='container main'>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: 'darkgrey',
                  fontWeight: 'bold'
                }}
              >
                &gt; Please SIGN UP or LOG IN from the top menu.
              </span>
            </div>
          </div>
        )
      )
    );
};

export const fetchInputs = () => dispatch => {
  dispatch(inputsLoading(true));

  return fetchWithAuth(
    baseUrl + 'inputs',
    { method: 'GET' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            `Error ${response.status} : ${response.statusText}`
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then(response => response.json())
    .then(inputs => dispatch(addInputs(inputs)))
    .catch(error =>
      dispatch(
        inputsFailed(
          <div className='container main'>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: 'darkgrey',
                  fontWeight: 'bold'
                }}
              >
                &gt; Please SIGN UP or LOG IN from the top menu.
              </span>
            </div>
          </div>
        )
      )
    );
};

export const fetchProInputs = () => dispatch => {
  dispatch(proInputsLoading(true));

  return fetchWithAuth(
    baseUrl + 'proInputs',
    { method: 'GET' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            `Error ${response.status} : ${response.statusText}`
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then(response => response.json())
    .then(proInputs => dispatch(addProInputs(proInputs)))
    .catch(error =>
      dispatch(
        proInputsFailed(
          <div className='container main'>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: 'darkgrey',
                  fontWeight: 'bold'
                }}
              >
                &gt; Please SIGN UP or LOG IN from the top menu.
              </span>
            </div>
          </div>
        )
      )
    );
};

export const kirksFailed = errmess => ({
  type: ActionTypes.KIRKS_FAILED,
  payload: errmess
});

export const inputsFailed = errmess => ({
  type: ActionTypes.INPUTS_FAILED,
  payload: errmess
});

export const proInputsFailed = errmess => ({
  type: ActionTypes.PROINPUTS_FAILED,
  payload: errmess
});

export const addKirks = kirks => ({
  type: ActionTypes.ADD_KIRKS,
  payload: kirks
});

export const addInputs = inputs => ({
  type: ActionTypes.ADD_INPUTS,
  payload: inputs
});

export const addProInputs = proInputs => ({
  type: ActionTypes.ADD_PROINPUTS,
  payload: proInputs
});

export const addKirk = kirk => ({
  type: ActionTypes.ADD_KIRK,
  payload: kirk
});

export const addInput = input => ({
  type: ActionTypes.ADD_INPUT,
  payload: input
});

export const addProInput = proInput => ({
  type: ActionTypes.ADD_PROINPUT,
  payload: proInput
});

export const editedKirk = kirk => ({
  type: ActionTypes.EDITED_KIRK,
  payload: kirk
});

export const editedInput = input => ({
  type: ActionTypes.EDITED_INPUT,
  payload: input
});

export const editedProInput = proInput => ({
  type: ActionTypes.EDITED_PROINPUT,
  payload: proInput
});

export const postKirk =
  (
    date,
    place,
    person,
    subject,
    reason,
    how,
    data,
    work,
    news,
    buy,
    utilities,
    // symptoms,
    events,
    health,
    foods,
    invests
  ) =>
  dispatch => {
    dispatch(kirksUpdatintg(true));
    const newKirk = {
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      how: how,
      data: data,
      work: work,
      news: news,
      buy: buy,
      utilities: utilities,
      // symptoms: symptoms,
      events: events,
      health: health,
      foods: foods,
      invests: invests
    };

    if (newKirk.date !== '') {
      newKirk.date = newKirk.date;
    } else {
      const today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const hour = today.getHours();
      const minute = today.getMinutes();

      // Get weekday in user's locale
      const week = today.toLocaleDateString(undefined, { weekday: 'short' });

      // Format as YYYY-M-D Week HH:MM
      newKirk.date = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
    }

    return fetchWithAuth(
      baseUrl + 'kirks',
      {
        method: 'POST',
        body: JSON.stringify(newKirk)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            dispatch(actions.reset('kirk'));
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(response => {
        dispatch(addKirk(response));
      })
      .catch(error => {
        alert('Your kirk could not be posted\nError: ' + error.message);
      });
  };

export const postInput =
  (date, place, person, subject, reason, condition, data, unit) => dispatch => {
    dispatch(inputsUpdatintg(true));
    const newInput = {
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      condition: condition,
      data: data,
      unit: unit
    };

    // console.log('inputLoading dispatched');

    if (newInput.date !== '') {
      newInput.date = newInput.date;
    } else {
      const today = new Date();

      // Get date components directly from Date object (locale-independent)
      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Month is 0-indexed
      const day = today.getDate();
      const hour = today.getHours();
      const minute = today.getMinutes();

      // Get weekday in user's locale
      const week = today.toLocaleDateString(undefined, { weekday: 'short' });

      // Format as YYYY-M-D Week HH:MM
      newInput.date = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
    }

    return fetchWithAuth(
      baseUrl + 'inputs',
      {
        method: 'POST',
        body: JSON.stringify(newInput)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(response => {
        dispatch(addInput(response));
      })
      .catch(error => {
        alert('Your input could not be posted\nError: ' + error.message);
      });
  };

export const postProInput =
  (
    date,
    place,
    person,
    subject,
    reason,
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
    condition6,
    condition7,
    condition8,
    condition9,
    condition10,
    condition11,
    condition12,
    condition13,
    condition14,
    condition15,
    condition16,
    condition17,
    condition18,
    condition19,
    condition20,
    data,
    unit
  ) =>
  dispatch => {
    dispatch(proInputsUpdatintg(true));

    const newProInput = {
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      condition1: condition1,
      condition2: condition2,
      condition3: condition3,
      condition4: condition4,
      condition5: condition5,
      condition6: condition6,
      condition7: condition7,
      condition8: condition8,
      condition9: condition9,
      condition10: condition10,
      condition11: condition11,
      condition12: condition12,
      condition13: condition13,
      condition14: condition14,
      condition15: condition15,
      condition16: condition16,
      condition17: condition17,
      condition18: condition18,
      condition19: condition19,
      condition20: condition20,
      data: data,
      unit: unit
    };

    if (newProInput.date !== '') {
      newProInput.date = newProInput.date;
    } else {
      const today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const hour = today.getHours();
      const minute = today.getMinutes();

      // Get weekday in user's locale
      const week = today.toLocaleDateString(undefined, { weekday: 'short' });

      // Format as YYYY-M-D Week HH:MM
      newProInput.date = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
    }

    return fetchWithAuth(
      baseUrl + 'proInputs',
      {
        method: 'POST',
        body: JSON.stringify(newProInput)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(response => {
        dispatch(addProInput(response));
      })
      .catch(error => {
        alert('Your proInput could not be posted\nError: ' + error.message);
      });
  };

export const requestLogin = username => {
  return {
    type: ActionTypes.LOGIN_REQUEST,
    username
  };
};

export const requestPwChange = username => {
  return {
    type: ActionTypes.PWCHANGE_REQUEST,
    username
  };
};

export const requestSignup = username => {
  return {
    type: ActionTypes.SIGNUP_REQUEST,
    username
  };
};

export const requestForgotPassword = email => {
  return {
    type: ActionTypes.FORGOTPW_REQUEST,
    email
  };
};

export const receiveLogin = response => {
  return {
    type: ActionTypes.LOGIN_SUCCESS,
    token: response.token,
    id: response.id
  };
};

export const receivePwChange = response => {
  return {
    type: ActionTypes.PWCHANGE_SUCCESS,
    token: response.token,
    id: response.id
  };
};

export const receiveSignup = response => {
  return {
    type: ActionTypes.SIGNUP_SUCCESS,
    token: response.token
  };
};

export const receiveForgotPassword = response => {
  return {
    type: ActionTypes.FORGOTPW_SUCCESS,
    token: response.token
  };
};

export const loginError = message => {
  return {
    type: ActionTypes.LOGIN_FAILURE,
    message
  };
};

export const pwChangeError = message => {
  return {
    type: ActionTypes.PWCHANGE_FAILURE,
    message
  };
};

export const signupError = message => {
  return {
    type: ActionTypes.SIGNUP_FAILURE,
    message
  };
};

export const forgotPasswordError = message => {
  return {
    type: ActionTypes.FORGOTPW_FAILURE,
    message
  };
};

export const getSearchWord = value => {
  return {
    type: ActionTypes.SEARCH_KIRKS,
    value
  };
};

// export const showAll = (value) => {
//   return {
//     type: ActionTypes.SHOW_ALL,
//     value,
//   };
// };

export const showMine = value => {
  return {
    type: ActionTypes.SHOW_MINE,
    value
  };
};
// export const updateKirkNum = (kirkNum) => ({
//   type: ActionTypes.UPDATE_KIRKNUM,
//   payload: kirkNum,
// });

export const updateKirkNum = kirkNum => {
  return {
    type: ActionTypes.UPDATE_KIRKNUM,
    kirkNum
  };
};

export const getKirkNum = kirkNum => dispatch => {
  dispatch(updateKirkNum(kirkNum));
};

// export const setKirkNum = (kirks) => ({
//   type: ActionTypes.ADD_KIRKS,
//   payload: kirks,
// });

export const loginUser = creds => dispatch => {
  // We dispatch requestLogin to kickoff the call to the API
  dispatch(requestLogin(creds.username));

  return (
    fetch(baseUrl + 'users/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(creds)
    })
      .then(
        response => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              'Error ' + response.status + ': ' + response.statusText
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          throw error;
        }
      )
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          // If login was successful, set the token in local storage
          localStorage.setItem('token', response.token);
          localStorage.setItem('refreshToken', response.refreshToken);
          localStorage.setItem('username', creds.username);
          localStorage.removeItem('creds');
          localStorage.setItem('id', response.id);
          // Dispatch the success action
          dispatch(receiveLogin(response));
          dispatch(fetchKirks());
          dispatch(fetchInputs());
          dispatch(fetchProInputs());
        } else {
          var error = new Error('Error ' + response.status);
          error.response = response;
          throw error;
        }
      })
      // .catch((error) => dispatch(loginError(error.message)));
      .catch(error => {
        alert('Login Error');
        dispatch(loginError(error.message));
      })
  );
};

export const pwChangeUser = creds => dispatch => {
  // We dispatch requestLogin to kickoff the call to the API
  dispatch(requestPwChange(creds.username));

  return fetch(baseUrl + 'users/changepassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(creds)
  })
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            'Error ' + response.status + ': ' + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        // If login was successful, set the token in local storage
        localStorage.setItem('token', response.token);
        localStorage.setItem('username', creds.username);
        localStorage.removeItem('creds');
        localStorage.setItem('id', response.id);
        // Dispatch the success action
        dispatch(receivePwChange(response));
        // window.confirm('Password changed!');
        alert('Password changed');

        dispatch(fetchKirks());
        dispatch(fetchInputs());
        dispatch(fetchProInputs());
      } else {
        // alert('Password NOT changed1. ' + response.status);
        var error = new Error('Error ' + response.status);
        error.response = response;
        throw error;
      }
    })
    .catch(error => {
      alert('Password NOT changed. ' + error.message);
      dispatch(pwChangeError(error.message));
    });
};

export const signupUser = creds => dispatch => {
  dispatch(requestSignup(creds.username));

  return fetch(baseUrl + 'users/signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(creds)
  })
    .then(
      response => {
        // console.log('1');
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            'Error ' + response.status + ': ' + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        // console.log('2');
        throw error;
      }
    )
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        // If login was successful, set the token in local storage
        localStorage.setItem('token', response.token);
        localStorage.setItem('username', creds.username);
        localStorage.removeItem('creds');
        localStorage.setItem('id', response.id);
        // Dispatch the success action
        dispatch(receiveSignup(response));
        dispatch(loginUser(creds));
        // dispatch(receiveLogin(response)); // Added on 2023.1.9
        // dispatch(fetchKirks());
        // dispatch(fetchInputs());
      } else {
        var error = new Error('Error ' + response.status);
        error.response = response;
        throw error;
      }
    })
    .catch(error => {
      alert(
        'Signup failed. Username and/or Email are already in use. Please use different one(s)'
      );
      dispatch(signupError(error.message));
    });
};

export const requestLogout = () => {
  return {
    type: ActionTypes.LOGOUT_REQUEST
  };
};

export const receiveLogout = () => {
  return {
    type: ActionTypes.LOGOUT_SUCCESS
  };
};

// Logs the user out
export const logoutUser = () => dispatch => {
  dispatch(requestLogout());
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('creds');
  localStorage.removeItem('username');
  localStorage.removeItem('id');
  // dispatch(kirksFailed('Error 401: Unauthorized'));
  // dispatch(inputsFailed('Error 401: Unauthorized')); //2023.3.12, to clear all list
  dispatch(
    kirksFailed(
      <div className='container main'>
        <div>
          <span
            style={{
              fontSize: 18,
              color: 'darkgrey',
              fontWeight: 'bold'
            }}
          >
            <p>&gt; Logged out.</p>
            <p>&gt; Please SIGN UP or LOG IN from the top menu.</p>
          </span>
        </div>
      </div>
    )
  );

  dispatch(
    inputsFailed(
      <div className='container main'>
        <div>
          <span
            style={{
              fontSize: 18,
              color: 'darkgrey',
              fontWeight: 'bold'
            }}
          >
            <p>&gt; Logged out.</p>
            <p>&gt; Please SIGN UP or LOG IN from the top menu.</p>
          </span>
        </div>
      </div>
    )
  );

  dispatch(
    proInputsFailed(
      <div className='container main'>
        <div>
          <span
            style={{
              fontSize: 18,
              color: 'darkgrey',
              fontWeight: 'bold'
            }}
          >
            <p>&gt; Logged out.</p>
            <p>&gt; Please SIGN UP or LOG IN from the top menu.</p>
          </span>
        </div>
      </div>
    )
  );

  dispatch(receiveLogout());
};

export const updateKirk =
  (
    kirkId,
    date,
    place,
    person,
    subject,
    reason,
    how,
    data,
    work,
    news,
    buy,
    utilities,
    // symptoms,
    events,
    health,
    foods,
    invests
  ) =>
  dispatch => {
    dispatch(kirksUpdatintg(true));

    const newKirk = {
      // kirkId,
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      how: how,
      data: data,
      work: work,
      news: news,
      buy: buy,
      utilities: utilities,
      // symptoms: symptoms,
      events: events,
      health: health,
      foods: foods,
      invests: invests
    };

    return fetchWithAuth(
      baseUrl + 'kirks/' + kirkId,
      {
        method: 'PUT',
        body: JSON.stringify(newKirk)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            dispatch(actions.reset('kirk'));
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(kirk => {
        dispatch(editedKirk(kirk));
      })
      .catch(error => {
        alert('Your kirk could not be updated\nError: ' + error.message);
      });
  };

export const updateInput =
  (inputId, date, place, person, subject, reason, condition, data, unit, pinned) =>
  dispatch => {
    dispatch(inputsUpdatintg(inputId));

    const newInput = {
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      condition: condition,
      data: data,
      unit: unit,
      pinned: pinned
    };

    if (newInput.date !== '') {
      newInput.date = newInput.date;
    } else {
      const today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const hour = today.getHours();
      const minute = today.getMinutes();

      // Get weekday in user's locale
      const week = today.toLocaleDateString(undefined, { weekday: 'short' });

      // Format as YYYY-M-D Week HH:MM
      newInput.date = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
    }

    return fetchWithAuth(
      baseUrl + 'inputs/' + inputId,
      {
        method: 'PUT',
        body: JSON.stringify(newInput)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(input => {
        dispatch(editedInput(input));
      })
      .catch(error => {
        alert('Your input could not be updated\nError: ' + error.message);
      });
  };

export const updateProInput =
  (
    proInputId,
    date,
    place,
    person,
    subject,
    reason,
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
    condition6,
    condition7,
    condition8,
    condition9,
    condition10,
    condition11,
    condition12,
    condition13,
    condition14,
    condition15,
    condition16,
    condition17,
    condition18,
    condition19,
    condition20,
    data,
    unit,
    pinned,
    saveScrollPosition, // Callback function to save scroll position
    restoreScrollPosition // Callback function to restore scroll position
  ) =>
  dispatch => {
    // Save the scroll position before resetting
    if (saveScrollPosition) saveScrollPosition();

    dispatch(proInputsUpdatintg(proInputId));

    const newProInput = {
      // _id: proInputId,
      date: date,
      place: place,
      person: person,
      subject: subject,
      reason: reason,
      condition1: condition1,
      condition2: condition2,
      condition3: condition3,
      condition4: condition4,
      condition5: condition5,
      condition6: condition6,
      condition7: condition7,
      condition8: condition8,
      condition9: condition9,
      condition10: condition10,
      condition11: condition11,
      condition12: condition12,
      condition13: condition13,
      condition14: condition14,
      condition15: condition15,
      condition16: condition16,
      condition17: condition17,
      condition18: condition18,
      condition19: condition19,
      condition20: condition20,
      data: data,
      unit: unit,
      pinned: pinned
    };

    if (newProInput.date !== '') {
      newProInput.date = newProInput.date;
    } else {
      const today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const hour = today.getHours();
      const minute = today.getMinutes();

      // Get weekday in user's locale
      const week = today.toLocaleDateString(undefined, { weekday: 'short' });

      // Format as YYYY-M-D Week HH:MM
      newProInput.date = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
    }

    return fetchWithAuth(
      baseUrl + 'proInputs/' + proInputId,
      {
        method: 'PUT',
        body: JSON.stringify(newProInput)
      },
      dispatch,
      logoutUser
    )
      .then(
        response => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              `Error ${response.status} : ${response.statusText}`
            );
            error.response = response;
            throw error;
          }
        },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then(response => response.json())
      .then(proInput => {
        dispatch(editedProInput(proInput));
        if (restoreScrollPosition) restoreScrollPosition();
      })
      .catch(error => {
        alert('Your proInput could not be updated\nError: ' + error.message);
      });
  };

// Inline cell edits must update only the edited field. Sending the entire
// row from a render snapshot lets overlapping saves overwrite sibling edits
// with stale values (especially noticeable when entering many conditions).
export const updateProInputFields = (proInputId, fields) => (dispatch, getState) => {
  dispatch(proInputsUpdatintg(proInputId));

  return fetchWithAuth(
    baseUrl + 'proInputs/' + proInputId,
    {
      method: 'PUT',
      body: JSON.stringify(fields)
    },
    dispatch,
    logoutUser
  )
    .then(response => {
      if (response.ok) return response;
      const error = new Error(`Error ${response.status} : ${response.statusText}`);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(proInput => {
      const current = getState().proInputs.proInputs.find(item => item._id === proInputId);
      // The server response can reflect an overlapping request's older
      // snapshot. Keep the current Redux row and apply only this patch.
      dispatch(editedProInput({
        ...(current || proInput),
        ...fields,
        updatedAt: proInput.updatedAt
      }));
    })
    .catch(error => {
      alert('Your proInput could not be updated\nError: ' + error.message);
    });
};

export const deleteKirk = kirkId => dispatch => {
  dispatch(kirksUpdatintg(true));

  return fetchWithAuth(
    baseUrl + 'kirks/' + kirkId,
    { method: 'DELETE' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            'Error ' + response.status + ': ' + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(kirks => {
      dispatch(addKirks(kirks));
    })
    .catch(error => dispatch(kirksFailed(error.message)));
};

export const deleteInput = inputId => dispatch => {
  dispatch(inputsUpdatintg(true));

  return fetchWithAuth(
    baseUrl + 'inputs/' + inputId,
    { method: 'DELETE' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            'Error ' + response.status + ': ' + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(inputs => {
      dispatch(addInputs(inputs));
    })
    .catch(error => dispatch(inputsFailed(error.message)));
};

export const deleteProInput = proInputId => dispatch => {
  dispatch(proInputsUpdatintg(true));

  return fetchWithAuth(
    baseUrl + 'proInputs/' + proInputId,
    { method: 'DELETE' },
    dispatch,
    logoutUser
  )
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            'Error ' + response.status + ': ' + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(proInputs => {
      dispatch(addProInputs(proInputs));
    })
    .catch(error => dispatch(proInputsFailed(error.message)));
};

export const forgotPassword = email => dispatch => {
  // const bearer = 'Bearer ' + localStorage.getItem('token');
  dispatch(requestForgotPassword(email));
  return fetch(baseUrl + 'users/forgot-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: bearer,
      'Access-Control-Allow-Origin': '*'
    },
    // header('Access-Control-Allow-Origin', '*')
    body: JSON.stringify(email),
    // credentials: 'no-cors',
    credentials: 'same-origin'
  })
    .then(
      response => {
        if (response.ok) {
          return response;
        } else {
          // reached the server but it says something wrong.
          var error = new Error(
            `Error ${response.status} : ${response.statusText}`
          );
          error.response = response;
          throw error;
        }
      },
      // if you even didn't get response from the server
      error => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        // Email confirmed. Then go forward to reset password.
        // localStorage.setItem('token', response.token);
        // localStorage.setItem('id', response.id);
        // Dispatch the success action
        dispatch(receiveForgotPassword(response));
        alert('Server response' + JSON.stringify(response));
        // dispatch(resetPassword());
      } else {
        var error = new Error('Error ' + response.status);
        error.response = response;
        throw error;
      }
    })
    .catch(error => {
      dispatch(forgotPasswordError(error.message));
      alert('Your email could not be posted\nError: ' + error.message);
    });
  // .then((response) => {
  //   dispatch(receiveForgotPassword(response));
  //   alert('Server response' + JSON.stringify(response));
  // })
  // .catch((error) => {
  //   console.log('Forgot Password', error.message);
  //   dispatch(forgotPasswordError(error.message));
  //   alert('Your email could not be posted\nError: ' + error.message);
  // });
};
